import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  CreateProjectDataType,
  DocumentDataType,
  FeatureDataType,
  ProjectStepOneDataType,
  ProjectTypeKey,
} from "store/types/project";

const intitialCreateProjectState: CreateProjectDataType = {
  name: "",
  description: "",
  production_type: "other",
  documents: [
    {
      file_path: "",
      file_size: 0,
      is_parsed_successfully: false,
    },
  ],
  features: {
    has_budget: false,
    has_coverage: false,
    has_character_breakdown: false,
    has_script_breakdown: false,
    has_schedule: false,
    max_budget: 0,
    min_budget: 0,
  },
};

const createProjectSlice = createSlice({
  name: "create project",
  initialState: intitialCreateProjectState,
  reducers: {
    setProjectInfo: (state, action: PayloadAction<ProjectStepOneDataType>) => {
      state.name = action.payload.name;
      state.description = action.payload.description;
    },
    setProjectType: (state, action: PayloadAction<ProjectTypeKey>) => {
      state.production_type = action.payload;
    },
    setProjectFeatures: (state, action: PayloadAction<FeatureDataType>) => {
      ((state.features.has_budget = action.payload.has_budget),
        (state.features.has_coverage = action.payload.has_coverage),
        (state.features.has_character_breakdown = action.payload.has_character_breakdown),
        (state.features.has_script_breakdown = action.payload.has_script_breakdown),
        (state.features.has_schedule = action.payload.has_schedule),
        (state.features.schedule_start_date = action.payload.schedule_start_date),
        (state.features.max_budget = (action.payload.max_budget as number) || 0),
        (state.features.min_budget = (action.payload.min_budget as number) || 0),
        (state.features.production_state = action.payload.production_state || null));
    },
    setScreenplayDoc: (state, action: PayloadAction<DocumentDataType>) => {
      state.documents[0].file_path = action.payload.file_path;
      state.documents[0].file_size = action.payload.file_size;
      state.documents[0].is_parsed_successfully = action.payload.is_parsed_successfully;
      state.documents[0].parsed_data = action.payload.parsed_data;
    },
  },
});

export const { setProjectInfo, setProjectType, setProjectFeatures, setScreenplayDoc } =
  createProjectSlice.actions;
export default createProjectSlice.reducer;
